export default "__VITE_ASSET__CFk0A4a4__"